<template>
  <v-layout wrap>
    <v-flex
      flex-grow-1
      xs12
    >
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">
              Редактирование пользователя
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
                sm12
                md12
              >
                <v-text-field
                  v-model="permissionsGroup.name"
                  v-validate="'required'"
                  label="Наименование"
                  name="name"
                  data-vv-as="Наименование"
                  :error-messages="errors.collect('name')"
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
              >
                <v-chips-combobox
                  :model="permissionsGroup.permissions"
                  :items="permissions"
                  item-text="name"
                  item-value="permission_id"
                  label="Права"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click.native="saveChanges"
          >
            Сохранить
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click.native="cancelEditing()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import VChipsCombobox from '../../shared-components/VChipsCombobox'
export default {
  name: 'PermissionsGroupEdit',
  components: {
    VChipsCombobox
  },
  props: {
    permissionsGroupData: {}
  },
  data () {
    return {
      permissionsGroup: {},
      users_groups: [],
      permissions: []
    }
  },
  mounted () {
    this.getPermissions()
    this.permissionsGroup = this.permissionsGroupData
  },
  methods: {
    cancelEditing: function () {
      this.$emit('cancel')
    },
    saveChanges () {
      this.axios.patch(`/api/permissions_groups/${this.permissionsGroupData.permissions_group_id}/`, this.permissionsGroup)
        .then(() => {
          this.$emit('edited')
        })
        .catch((err) => {
          this.$emit('editError', err.response.data)
        })
    },
    getPermissions () {
      axios.get(`/api/permissions/`)
        .then((response) => {
          this.permissions = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/permissions-groups/PermissionsGroupEdit.vue